import React, { PureComponent } from "react";
import { Link } from "react-router-dom";

import ROUTE_CONSTANTS from "../../../routes/ROUTE_CONSTANTS";
import christmasSongsOnBassGuitarAlbumCoverImage from "./christmas-songs-on-bass-guitar-album-cover.jpg";

class ChristmasSongsOnBassGuitarPage extends PureComponent {
  render() {
    return (
      <div>
        <h1>Music</h1>

        <div
          style={{
            margin: 5
          }}
        >
          <hr />

          <div>
            <Link to={ROUTE_CONSTANTS.MUSIC_CHRISTMAS_SONGS_ON_BASS_GUITAR}>
              <h2>Christmas Songs On Bass Guitar - album by Mark Allan</h2>
            </Link>
            <p>All bass. All Christmas.</p>
            <p>
              Recorded in Saint Paul, Minnesota in July, 2018.
              <br />
              Released September 13, 2018.
            </p>
            <Link to={ROUTE_CONSTANTS.MUSIC_CHRISTMAS_SONGS_ON_BASS_GUITAR}>
              <img
                alt="Christmas Songs On Bass Guitar - album by Mark Allan - 2018"
                src={christmasSongsOnBassGuitarAlbumCoverImage}
                style={{
                  width: "256",
                  height: "auto",
                  maxWidth: "256"
                }}
              />
            </Link>
            <br />
            Album cover photography by{" "}
            <a
              href="http://www.lisaroyphotography.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.LisaRoyPhotography.com
            </a>
          </div>

          <h3>Available on:</h3>
          <p>
            <a
              href="https://itunes.apple.com/us/album/christmas-songs-on-bass-guitar/1435739765"
              target="_blank"
              rel="noopener noreferrer"
            >
              iTunes
            </a>
          </p>
          <p>
            <a
              href="https://open.spotify.com/album/5KjCJHjnIkO6JXjjenIdEN?si=OnSDcFngQ_SMJ4ynF7KnpA"
              target="_blank"
              rel="noopener noreferrer"
            >
              Spotify
            </a>
          </p>
          <p>
            <a
              href="https://www.amazon.com/gp/product/B07H73J6GD/?tag=distrokid06-20"
              target="_blank"
              rel="noopener noreferrer"
            >
              Amazon
            </a>
          </p>
          <p>
            <a
              href="https://music.youtube.com/playlist?list=OLAK5uy_lqRiqenF97cCtLD4loFh3s9XOVCcTSED8"
              target="_blank"
              rel="noopener noreferrer"
            >
              YouTube Music
            </a>
          </p>
          <p>
            <a
              href="https://www.deezer.com/us/album/72705822 "
              target="_blank"
              rel="noopener noreferrer"
            >
              Deezer
            </a>
          </p>
          <p>
            <a
              href="https://us.napster.com/artist/mark-allan/album/christmas-songs-on-bass-guitar"
              target="_blank"
              rel="noopener noreferrer"
            >
              Napster
            </a>
          </p>
        </div>
      </div>
    );
  }
}

export default ChristmasSongsOnBassGuitarPage;



// WEBPACK FOOTER //
// ./src/routes/music/christmas-songs-on-bass-guitar/ChristmasSongsOnBassGuitarPage.js